import React from 'react';
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";

// KeepAlive keeps every cached tab mounted in the same React tree. Without a boundary here,
// an uncaught error thrown while rendering ANY tab (active or inactive) unwinds past KeepAlive
// entirely, which can blank out tabs opened afterwards. Wrapping each tab's content isolates the
// crash to that one tab instead of poisoning the shared render tree.
class TabErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {error: null};
    }

    static getDerivedStateFromError(error) {
        return {error};
    }

    componentDidCatch(error, info) {
        console.error('Tab render error:', error, info?.componentStack);
    }

    componentDidUpdate(prevProps) {
        if (this.state.error && prevProps.cacheKey !== this.props.cacheKey) {
            this.setState({error: null});
        }
    }

    render() {
        if (this.state.error) {
            return (
                <MDBox p={3}>
                    <MDTypography variant="h6" color="error">
                        Something went wrong rendering this page.
                    </MDTypography>
                    <MDTypography variant="body2" color="text">
                        {String(this.state.error?.message || this.state.error)}
                    </MDTypography>
                </MDBox>
            );
        }
        return this.props.children;
    }
}

export default TabErrorBoundary;
